import { mapData } from "@/utilities/DataMapping";

import { ISwmScapaHazard, SwmScapaHazard } from "@/model/workPermits/SwmScapaHazard";

export interface ISwmScapaFieldSet {

    ramsReference: string;

    isConfinedSpace: boolean;
    confinedSpaceIsPersonnelTrained: boolean;
    confinedSpaceIsNotWorkingAlone: boolean;
    confinedSpaceIsTopMan: boolean;
    confinedSpaceIsHarness: boolean;
    confinedSpaceIsRadio: boolean;
    confinedSpaceIsGasMonitor: boolean;
    confinedSpaceIsBumpCap: boolean;
    confinedSpaceIsSafetyFootwear: boolean;
    confinedSpaceIsSafetyGlasses: boolean;
    confinedSpaceIsOther: boolean;
    confinedSpaceOther: string;
    confinedSpaceEmergency: string;

    isWorkingAtHeight: boolean;
    workingAtHeightArePersonnelTrained: boolean;
    workingAtHeightIsHarness: boolean;
    workingAtHeightIsBumpCap: boolean;
    workingAtHeightIsSafetyGlasses: boolean;
    workingAtHeightIsSafetyFootwear: boolean;
    workingAtHeightIsOther: boolean;
    workingAtHeightOther: string;
    workingAtHeightEmergency: string;

    isHotWorks: boolean;

    isIsolationRequired: boolean;
    isIsolationRequiredElectrical: boolean;
    isIsolationRequiredSteam: boolean;
    isIsolationRequiredPneumatic: boolean;
    isIsolationRequiredOther: boolean;
    isolationRequiredOther: string;

    isHazardsAndControlMeasures: boolean;
    hazardsAndControlMeasures: Array<ISwmScapaHazard>;

    location: string;
    additionalInfo: string;
}

const defaultAdditionalInfo = `Site Contacts
  - Mark Cafferkey - 07464 534097
  - Alternative Contact - Andrew Pearson 07584172979
  - Security - 07776 598246

For any emergency contact security.
For First Aid - Contact Security.
In the event of a Fire Alarm - leave all tools and equipment and immediately report to the Security Gatehouse.`;

export class SwmScapaFieldSet implements ISwmScapaFieldSet {

    constructor(data?: any) {
        if (data) this.update(data);
    }

    update(data: any): ISwmScapaFieldSet {
        if(data) mapData(data, {
            root: () => this
        });
        if (this.additionalInfo == "") this.additionalInfo = defaultAdditionalInfo;
        return this;
    }

    ramsReference: string = "";

    isConfinedSpace: boolean = false;
    confinedSpaceIsPersonnelTrained: boolean = false;
    confinedSpaceIsNotWorkingAlone: boolean = false;
    confinedSpaceIsTopMan: boolean = false;
    confinedSpaceIsHarness: boolean = false;
    confinedSpaceIsRadio: boolean = false;
    confinedSpaceIsGasMonitor: boolean = false;
    confinedSpaceIsBumpCap: boolean = false;
    confinedSpaceIsSafetyFootwear: boolean = false;
    confinedSpaceIsSafetyGlasses: boolean = false;
    confinedSpaceIsOther: boolean = false;
    confinedSpaceOther: string = "";
    confinedSpaceEmergency: string = "";

    isWorkingAtHeight: boolean = false;
    workingAtHeightArePersonnelTrained: boolean = false;
    workingAtHeightIsHarness: boolean = false;
    workingAtHeightIsBumpCap: boolean = false;
    workingAtHeightIsSafetyGlasses: boolean = false;
    workingAtHeightIsSafetyFootwear: boolean = false;
    workingAtHeightIsOther: boolean = false;
    workingAtHeightOther: string = "";
    workingAtHeightEmergency: string = "";

    isHotWorks: boolean = false;

    isIsolationRequired: boolean = false;
    isIsolationRequiredElectrical: boolean = false;
    isIsolationRequiredSteam: boolean = false;
    isIsolationRequiredPneumatic: boolean = false;
    isIsolationRequiredOther: boolean = false;
    isolationRequiredOther: string = "";

    isHazardsAndControlMeasures: boolean = false;
    hazardsAndControlMeasures: Array<SwmScapaHazard> = [];

    location: string = "";
    additionalInfo: string = defaultAdditionalInfo;

    get areNoHazards (): boolean {
        return (this.hazardsAndControlMeasures?.length ?? 0) === 0;
    }
}
